// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"556":"e0f0afa7","820":"cdc8e6cd","861":"84d77f85","949":"22212959"}[chunkId] + ".chunk.css";
};